module.exports = __webpack_public_path__ + "img/chaye.a12e00e3.png";